import notification from 'antd/lib/notification'
import './index.less'

export default notification



// WEBPACK FOOTER //
// ./src/elements/notification/index.js